import { type Feature } from 'geojson';
import L from 'leaflet';
import React from 'react';
import ReactDOM from 'react-dom';
import { CameraFavoriteToggler } from '../../Cameras/CameraFavoriteToggler';
import { FavoriteStorage } from '../../Util/FavoriteStorage';
import { SvgIcon } from '../Extensions/SvgIcon';
import { ClusteredMarkerLayer } from '../Layers/ClusteredMarkersLayer';
import type { ClusteredMarkerLayerOptions } from '../Layers/Layers.types';
import TrafficCamera from '../PopupTemplates/TrafficCamera';
import { TrafficCameraSource } from '../Sources/TrafficCameraSource';

export function trafficCamera(region: string, cameraPageId?: string, options?: ClusteredMarkerLayerOptions): ClusteredMarkerLayer {
    const defaultOptions: ClusteredMarkerLayerOptions = {
        name: 'Trafikkamera',
        itemPlural: 'trafikkameror',
        defaultIconId: 'symbol_camera',
        source: new TrafficCameraSource(region, cameraPageId),
        createInformationLayer: function (feature, marker) {
            const infoLayer = L.marker(marker.getLatLng(), {
                icon: new SvgIcon({
                    iconId: 'triangle',
                    iconSize: [16, 8],
                    iconAnchor: [8, 28],
                    className: 'marker-with-outline',
                }),
                rotationAngle: feature.properties.direction,
                rotationOrigin: '8px 28px',
            });
            marker.on('move', function (e: L.MarkerEvent) {
                if (e.oldLatLng !== e.latlng) {
                    infoLayer.setLatLng(e.latlng);
                }
            });
            return infoLayer;
        },
        popupTemplate: TrafficCamera,
        popupOptions: {
            minWidth: 280,
        },
        onPopupOpen: (e) => {
            setTimeout(function () {
                ReactDOM.render(
                    React.createElement(CameraFavoriteToggler, { pageId: e.target.feature.id, region: region }),
                    document.getElementById('popup-favorite-toggler'),
                );
            }, 200);
        },
        defaultFilter: {
            filterFn: function (features: Feature[]) {
                const key = 'MyCameraPages' + region.toUpperCase();
                const favorites = new FavoriteStorage(key).getFavorites();
                return features.filter((feature) => favorites.indexOf(feature.id.toString()) > -1);
            },
            order: -1,
        },
        onMarkerAdd: function (marker, feature) {
            marker.getElement().setAttribute('data-camera-page-id', '' + feature.id);
        },
    };

    return new ClusteredMarkerLayer({ ...defaultOptions, ...options });
}
